// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset */
html {
  position: relative;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -webkit-overflow-scrolling: touch;
}

body {
  color: inherit;
  font-family: "Noto Sans Display", sans-serif;
  word-wrap: break-word;
  word-break: keep-all;
  -webkit-text-size-adjust: none;
}

body * {
  box-sizing: border-box;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
blockquote,
th,
td,
p,
button {
  margin: 0;
  padding: 0;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

ol,
ul,
li {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

fieldset,
img,
abbr,
acronym {
  border: 0;
}

img {
  max-width: 100%;
  vertical-align: top;
}

i,
em,
address {
  font-style: normal;
}

a {
  color: inherit;
  text-decoration: none;
  word-break: break-all;
}

caption,
legend {
  width: 0;
  height: 0;
  text-indent: -9999em;
  overflow: hidden;
  font-size: 0;
}

label,
button {
  cursor: pointer;
  vertical-align: middle;
}

input,
textarea,
select,
button {
  margin: 0;
  padding: 0;
  color: inherit;
  font-size: 12px;
  font-weight: 400;
  font-family: "Noto Sans KR", sans-serif;
  vertical-align: middle;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

input::-webkit-input-placeholder {
  color: inherit;
}

input::-moz-input-placeholder {
  color: inherit;
}

input:-ms-input-placeholder {
  color: inherit;
}

textarea {
  border: 1px solid #666;
  resize: none;
  overflow-y: auto;
}

button {
  overflow: visible;
  border: 0 none;
  background: none;
  vertical-align: top;
  cursor: pointer;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.breadcrumb {
  border-bottom: none;
}

/* global */
.none {
  display: none;
}

.hidden {
  position: absolute;
  top: 0;
  left: -9999px;
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  text-indent: -9999px;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.left {
  text-align: left !important;
}

.center {
  text-align: center !important;
}

.right {
  text-align: right !important;
}

.block {
  display: block;
}

.inblock {
  display: inline-block;
}

.clear:after {
  content: "";
  display: block;
  clear: both;
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bold {
  font-weight: bold !important;
}

/* 건너뛰기 네비게이션 */
#skip_nav {
  width: 100%;
  height: 0;
  text-align: center;
  overflow: hidden;
}

#skip_nav a {
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  font-weight: 800;
  float: left;
}

#skip_nav a:focus,
#skip_nav a:hover,
#skip_nav a:active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
  text-decoration: underline;
  background-color: #000;
  overflow: visible;
  z-index: 9999;
}

/* style */

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  background-color: #f9f9f9;
}

.wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 500px;
  height: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  overflow-y: auto;
}

/* .container {background: #fff; width: 80%; max-width: 350px; padding: 24px; border-radius: 5px; box-shadow: 8px 12px 10px #d9d9d9; display: flex; flex-direction: column; justify-content: space-between; margin-bottom: 100px; padding-top: 5vh;} */
.container {
  background: #fff;
  width: 100%;
  max-width: 350px;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 8px 12px 10px #d9d9d9;
  display: flex;
  flex-direction: column;
  position: relative;
}

.container .top .icon-area {
  width: 68px;
  height: 68px;
  margin: 0 auto;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container .top .icon-area img {
  width: 100%;
  display: block;
  margin: auto;
}

/* .container .top h1 {text-align: center;} */
.container .top h1 {
  text-align: center;
  margin: 0;
  font-size: 1.8rem;
}

.container .top p {
  text-align: center;
  margin-bottom: 10px;
}

.dot-container {
  position: relative;
  width: 10px;
  height: 10px;
  display: inline-block;
  vertical-align: middle;
}

.dot {
  position: absolute;
  border-radius: 50%;
}

/* 바깥 원 (outer dot) */
.dot.outer {
  width: 10px;
  height: 10px;
  background-color: #1d8399;
}

/* 안쪽 원 (inner dot) */
.dot.inner {
  width: 4px;
  height: 4px;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sub-tit-area p {
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
  font-size: 14px;
}

.l-button {
  font-size: 1.8rem;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  height: 4.6rem;
  padding: 15px;
}

.m-button {
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  height: 3rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
}

.solid {
  background: #f0c777;
  border: 0.5px solid #f0c777;

  color: #242424;
}

.inp-area {
  margin-bottom: 10px;
}

.inp-area > input {
  margin-top: 10px;
}

.input-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 8px;
}

.input-wrapper .label {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: inherit;
  pointer-events: none;
  line-height: 1;
}

.input-wrapper input {
  height: 2.875rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 120px;
  /* !! padding-left는 아이디 |와 입력내용의 간격 없어지면 겹쳐진 것 처럼 보임 */
  display: flex;
  align-items: center;
  width: 300px;
}

/* .container .top {margin-bottom: 42px;} */
.container .top {
  background: #fff;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.reset-pw-area .sub-tit-area {
  margin-top: 42px;
}

.reset-pw-area .txt-area p {
  margin-bottom: 8px;
  padding-left: 18px;
}

.reset-pw-area .sub-tit-area p {
  font-size: 1.2rem;
  font-weight: 700;
}

.reset-pin-area .sub-tit-area {
  margin-top: 42px;
}

.reset-pin-area .txt-area p {
  margin-bottom: 8px;
  padding-left: 18px;
}

.reset-pin-area .sub-tit-area p {
  font-size: 1.2rem;
  font-weight: 700;
}

/* .ss-area .sub-tit-area {margin-top: 42px;} */
.ss-area .sub-tit-area {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 42px;
}

.ss-area .sub-tit-area p,
.ss-area .sub-tit-area span.value {
  margin: 0;
  font-size: 14px;
}

.ss-area .sub-tit-area span.value {
  font-size: 19.2px;
  display: flex;
  align-items: center;
}

.ss-area .sub-tit-area:nth-child(2) {
  margin-top: 0px;
  margin-bottom: 8px;
}

.ss-area .sub-tit-area p {
  font-size: 1.2rem;
  font-weight: 700;
}

.ss-area .input-area .input-wrapper span {
  display: flex;
  justify-content: end;
  width: 270px;
}

.ss-area .input-area .input-wrapper input {
  padding-right: 42px;
  text-align: right;
}

button {
  width: 300px;
}

/* 회원 출금제한 영역 */
.withdraw-limit-area .sub-tit-area {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 42px;
  margin-bottom: 16px;
}

.withdraw-limit-area .sub-tit-area p {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
}


.withdraw-limit-area .input-area .date-wrapper {
  position: relative;
  width: 100%;
}

/* 캘린더 아이콘 스타일 - 크기 조절 */
.withdraw-limit-area .input-area .date-wrapper .calendar-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  opacity: 1;
  pointer-events: none;
  z-index: 2;
}

/* react-datepicker 스타일 */
.withdraw-limit-area .input-area .date-wrapper .react-datepicker-wrapper {
  width: 100%;
}

.withdraw-limit-area .input-area .date-wrapper input.date-input {
  width: 300px;
  padding-left: 38px;
  height: 2.875rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.withdraw-limit-area .input-area .date-wrapper input.date-input::placeholder {
  color: #999;
}

.withdraw-limit-area .input-area .date-wrapper input.date-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.withdraw-limit-area .input-area .date-wrapper input.date-input {
  caret-color: transparent;
  cursor: pointer;
}

/* react-datepicker 팝업 스타일 */
.react-datepicker {
  font-family: "Noto Sans KR", sans-serif !important;
  font-size: 11px !important;
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.react-datepicker__month-container {
  float: left !important;
}

.react-datepicker__header {
  background-color: #f0c777 !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0 !important;
  padding: 8px !important;
}

.react-datepicker__current-month {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #333 !important;
  margin-bottom: 5px !important;
}

.react-datepicker__day-names {
  margin-bottom: 0 !important;
}

.react-datepicker__day-name {
  color: #666 !important;
  font-weight: 500 !important;
  width: 26px !important;
  line-height: 26px !important;
  margin: 1px !important;
  font-size: 11px !important;
}

.react-datepicker__month {
  margin: 5px !important;
}

.react-datepicker__day {
  width: 26px !important;
  height: 26px !important;
  line-height: 26px !important;
  margin: 1px !important;
  border-radius: 4px !important;
  font-size: 11px !important;
}

.react-datepicker__day:hover {
  background-color: #f0c777 !important;
  color: #333 !important;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: #f0c777 !important;
  color: #242424 !important;
}

.react-datepicker__day--selected:hover {
  background-color: #e0b767 !important;
  color: #242424 !important;
}

.react-datepicker__time-container {
  border-left: 1px solid #ddd !important;
  width: 70px !important;
}

.react-datepicker__time-container .react-datepicker__time {
  background: #fff !important;
}

.react-datepicker__time-container .react-datepicker__time-box {
  width: 70px !important;
}

.react-datepicker__time-container .react-datepicker__time-list {
  height: 180px !important;
}

.react-datepicker__time-container .react-datepicker__time-list-item {
  height: 24px !important;
  line-height: 24px !important;
  padding: 0 8px !important;
  font-size: 11px !important;
}

.react-datepicker__time-container .react-datepicker__time-list-item:hover {
  background-color: #f0c777 !important;
}

.react-datepicker__time-container .react-datepicker__time-list-item--selected {
  background-color: #f0c777 !important;
  color: #242424 !important;
}

.react-datepicker__time-container .react-datepicker__header--time {
  padding: 8px !important;
}

.react-datepicker__navigation {
  top: 10px !important;
}

.react-datepicker__navigation--previous {
  left: 8px !important;
}

.react-datepicker__navigation--next {
  right: 78px !important;
}

.react-datepicker__navigation-icon::before {
  border-color: #242424 !important;
}

.react-datepicker-popper {
  z-index: 100 !important;
}

.react-datepicker__triangle {
  display: none !important;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  margin-top: 8px;
}

.checkbox-wrapper input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #f0c777;
}

.checkbox-wrapper label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

@media (max-width: 420px) {
  /* .wrap {padding-top: 68vh;} */
  .container {
    width: 95%;
  }

  .wrap {
    padding: 0;
  }

  .input-wrapper input {
    width: 100%;
  }

  .solid {
    width: 100%;
  }

  .ss-area .input-area .input-wrapper span {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,SAAS;EACT,UAAU;AACZ;;AAEA,gDAAgD;AAChD;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;;EAIE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,sPAAsP;AACtP;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;;EAE3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kDAAkD;EAClD,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* reset */\r\nhtml {\r\n  position: relative;\r\n  height: 100%;\r\n  -webkit-font-smoothing: antialiased;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\nbody {\r\n  color: inherit;\r\n  font-family: \"Noto Sans Display\", sans-serif;\r\n  word-wrap: break-word;\r\n  word-break: keep-all;\r\n  -webkit-text-size-adjust: none;\r\n}\r\n\r\nbody * {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody,\r\ndiv,\r\ndl,\r\ndt,\r\ndd,\r\nul,\r\nol,\r\nli,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\npre,\r\nform,\r\nfieldset,\r\ninput,\r\ntextarea,\r\nblockquote,\r\nth,\r\ntd,\r\np,\r\nbutton {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* HTML5 display-role reset for older browsers */\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary {\r\n  display: block;\r\n}\r\n\r\naudio,\r\ncanvas,\r\nvideo {\r\n  display: inline-block;\r\n}\r\n\r\nol,\r\nul,\r\nli {\r\n  list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n  quotes: none;\r\n}\r\n\r\nblockquote:before,\r\nblockquote:after,\r\nq:before,\r\nq:after {\r\n  content: \"\";\r\n  content: none;\r\n}\r\n\r\ntable {\r\n  table-layout: fixed;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n}\r\n\r\nfieldset,\r\nimg,\r\nabbr,\r\nacronym {\r\n  border: 0;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n  vertical-align: top;\r\n}\r\n\r\ni,\r\nem,\r\naddress {\r\n  font-style: normal;\r\n}\r\n\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  word-break: break-all;\r\n}\r\n\r\ncaption,\r\nlegend {\r\n  width: 0;\r\n  height: 0;\r\n  text-indent: -9999em;\r\n  overflow: hidden;\r\n  font-size: 0;\r\n}\r\n\r\nlabel,\r\nbutton {\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n}\r\n\r\ninput,\r\ntextarea,\r\nselect,\r\nbutton {\r\n  margin: 0;\r\n  padding: 0;\r\n  color: inherit;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  font-family: \"Noto Sans KR\", sans-serif;\r\n  vertical-align: middle;\r\n}\r\n\r\ninput:-webkit-autofill {\r\n  -webkit-box-shadow: 0 0 0px 1000px white inset;\r\n}\r\n\r\ninput::-webkit-input-placeholder {\r\n  color: inherit;\r\n}\r\n\r\ninput::-moz-input-placeholder {\r\n  color: inherit;\r\n}\r\n\r\ninput:-ms-input-placeholder {\r\n  color: inherit;\r\n}\r\n\r\ntextarea {\r\n  border: 1px solid #666;\r\n  resize: none;\r\n  overflow-y: auto;\r\n}\r\n\r\nbutton {\r\n  overflow: visible;\r\n  border: 0 none;\r\n  background: none;\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton::-moz-focus-inner,\r\ninput::-moz-focus-inner {\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n\r\n.breadcrumb {\r\n  border-bottom: none;\r\n}\r\n\r\n/* global */\r\n.none {\r\n  display: none;\r\n}\r\n\r\n.hidden {\r\n  position: absolute;\r\n  top: 0;\r\n  left: -9999px;\r\n  width: 0;\r\n  height: 0;\r\n  font-size: 0;\r\n  line-height: 0;\r\n  text-indent: -9999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.fl {\r\n  float: left;\r\n}\r\n\r\n.fr {\r\n  float: right;\r\n}\r\n\r\n.left {\r\n  text-align: left !important;\r\n}\r\n\r\n.center {\r\n  text-align: center !important;\r\n}\r\n\r\n.right {\r\n  text-align: right !important;\r\n}\r\n\r\n.block {\r\n  display: block;\r\n}\r\n\r\n.inblock {\r\n  display: inline-block;\r\n}\r\n\r\n.clear:after {\r\n  content: \"\";\r\n  display: block;\r\n  clear: both;\r\n}\r\n\r\n.ellipsis {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.bold {\r\n  font-weight: bold !important;\r\n}\r\n\r\n/* 건너뛰기 네비게이션 */\r\n#skip_nav {\r\n  width: 100%;\r\n  height: 0;\r\n  text-align: center;\r\n  overflow: hidden;\r\n}\r\n\r\n#skip_nav a {\r\n  color: #fff;\r\n  font-size: 16px;\r\n  line-height: 30px;\r\n  font-weight: 800;\r\n  float: left;\r\n}\r\n\r\n#skip_nav a:focus,\r\n#skip_nav a:hover,\r\n#skip_nav a:active {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 30px;\r\n  text-decoration: underline;\r\n  background-color: #000;\r\n  overflow: visible;\r\n  z-index: 9999;\r\n}\r\n\r\n/* style */\r\n\r\nbody {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  margin: 0;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 500px;\r\n  height: 100%;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* .container {background: #fff; width: 80%; max-width: 350px; padding: 24px; border-radius: 5px; box-shadow: 8px 12px 10px #d9d9d9; display: flex; flex-direction: column; justify-content: space-between; margin-bottom: 100px; padding-top: 5vh;} */\r\n.container {\r\n  background: #fff;\r\n  width: 100%;\r\n  max-width: 350px;\r\n  padding: 24px;\r\n  border-radius: 5px;\r\n  box-shadow: 8px 12px 10px #d9d9d9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n.container .top .icon-area {\r\n  width: 68px;\r\n  height: 68px;\r\n  margin: 0 auto;\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.container .top .icon-area img {\r\n  width: 100%;\r\n  display: block;\r\n  margin: auto;\r\n}\r\n\r\n/* .container .top h1 {text-align: center;} */\r\n.container .top h1 {\r\n  text-align: center;\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.container .top p {\r\n  text-align: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.dot-container {\r\n  position: relative;\r\n  width: 10px;\r\n  height: 10px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.dot {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* 바깥 원 (outer dot) */\r\n.dot.outer {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #1d8399;\r\n}\r\n\r\n/* 안쪽 원 (inner dot) */\r\n.dot.inner {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color: #fff;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.sub-tit-area p {\r\n  display: inline-block;\r\n  margin-left: 8px;\r\n  vertical-align: middle;\r\n  font-size: 14px;\r\n}\r\n\r\n.l-button {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  height: 4.6rem;\r\n  padding: 15px;\r\n}\r\n\r\n.m-button {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  height: 3rem;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 300px;\r\n}\r\n\r\n.solid {\r\n  background: #f0c777;\r\n  border: 0.5px solid #f0c777;\r\n\r\n  color: #242424;\r\n}\r\n\r\n.inp-area {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.inp-area > input {\r\n  margin-top: 10px;\r\n}\r\n\r\n.input-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.input-wrapper .label {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: inherit;\r\n  pointer-events: none;\r\n  line-height: 1;\r\n}\r\n\r\n.input-wrapper input {\r\n  height: 2.875rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  padding-top: 24px;\r\n  padding-bottom: 24px;\r\n  padding-left: 120px;\r\n  /* !! padding-left는 아이디 |와 입력내용의 간격 없어지면 겹쳐진 것 처럼 보임 */\r\n  display: flex;\r\n  align-items: center;\r\n  width: 300px;\r\n}\r\n\r\n/* .container .top {margin-bottom: 42px;} */\r\n.container .top {\r\n  background: #fff;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.reset-pw-area .sub-tit-area {\r\n  margin-top: 42px;\r\n}\r\n\r\n.reset-pw-area .txt-area p {\r\n  margin-bottom: 8px;\r\n  padding-left: 18px;\r\n}\r\n\r\n.reset-pw-area .sub-tit-area p {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.reset-pin-area .sub-tit-area {\r\n  margin-top: 42px;\r\n}\r\n\r\n.reset-pin-area .txt-area p {\r\n  margin-bottom: 8px;\r\n  padding-left: 18px;\r\n}\r\n\r\n.reset-pin-area .sub-tit-area p {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* .ss-area .sub-tit-area {margin-top: 42px;} */\r\n.ss-area .sub-tit-area {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 42px;\r\n}\r\n\r\n.ss-area .sub-tit-area p,\r\n.ss-area .sub-tit-area span.value {\r\n  margin: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.ss-area .sub-tit-area span.value {\r\n  font-size: 19.2px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ss-area .sub-tit-area:nth-child(2) {\r\n  margin-top: 0px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ss-area .sub-tit-area p {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.ss-area .input-area .input-wrapper span {\r\n  display: flex;\r\n  justify-content: end;\r\n  width: 270px;\r\n}\r\n\r\n.ss-area .input-area .input-wrapper input {\r\n  padding-right: 42px;\r\n  text-align: right;\r\n}\r\n\r\nbutton {\r\n  width: 300px;\r\n}\r\n\r\n/* 회원 출금제한 영역 */\r\n.withdraw-limit-area .sub-tit-area {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 42px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.withdraw-limit-area .sub-tit-area p {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n\r\n.withdraw-limit-area .input-area .date-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n/* 캘린더 아이콘 스타일 - 크기 조절 */\r\n.withdraw-limit-area .input-area .date-wrapper .calendar-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 20px;\r\n  height: 20px;\r\n  opacity: 1;\r\n  pointer-events: none;\r\n  z-index: 2;\r\n}\r\n\r\n/* react-datepicker 스타일 */\r\n.withdraw-limit-area .input-area .date-wrapper .react-datepicker-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.withdraw-limit-area .input-area .date-wrapper input.date-input {\r\n  width: 300px;\r\n  padding-left: 38px;\r\n  height: 2.875rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.withdraw-limit-area .input-area .date-wrapper input.date-input::placeholder {\r\n  color: #999;\r\n}\r\n\r\n.withdraw-limit-area .input-area .date-wrapper input.date-input:disabled {\r\n  background-color: #f5f5f5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.withdraw-limit-area .input-area .date-wrapper input.date-input {\r\n  caret-color: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n/* react-datepicker 팝업 스타일 */\r\n.react-datepicker {\r\n  font-family: \"Noto Sans KR\", sans-serif !important;\r\n  font-size: 11px !important;\r\n  border: 1px solid #ddd !important;\r\n  border-radius: 8px !important;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\r\n}\r\n\r\n.react-datepicker__month-container {\r\n  float: left !important;\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: #f0c777 !important;\r\n  border-bottom: none !important;\r\n  border-radius: 8px 8px 0 0 !important;\r\n  padding: 8px !important;\r\n}\r\n\r\n.react-datepicker__current-month {\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  color: #333 !important;\r\n  margin-bottom: 5px !important;\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n  color: #666 !important;\r\n  font-weight: 500 !important;\r\n  width: 26px !important;\r\n  line-height: 26px !important;\r\n  margin: 1px !important;\r\n  font-size: 11px !important;\r\n}\r\n\r\n.react-datepicker__month {\r\n  margin: 5px !important;\r\n}\r\n\r\n.react-datepicker__day {\r\n  width: 26px !important;\r\n  height: 26px !important;\r\n  line-height: 26px !important;\r\n  margin: 1px !important;\r\n  border-radius: 4px !important;\r\n  font-size: 11px !important;\r\n}\r\n\r\n.react-datepicker__day:hover {\r\n  background-color: #f0c777 !important;\r\n  color: #333 !important;\r\n}\r\n\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day--keyboard-selected {\r\n  background-color: #f0c777 !important;\r\n  color: #242424 !important;\r\n}\r\n\r\n.react-datepicker__day--selected:hover {\r\n  background-color: #e0b767 !important;\r\n  color: #242424 !important;\r\n}\r\n\r\n.react-datepicker__time-container {\r\n  border-left: 1px solid #ddd !important;\r\n  width: 70px !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time {\r\n  background: #fff !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time-box {\r\n  width: 70px !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time-list {\r\n  height: 180px !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time-list-item {\r\n  height: 24px !important;\r\n  line-height: 24px !important;\r\n  padding: 0 8px !important;\r\n  font-size: 11px !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time-list-item:hover {\r\n  background-color: #f0c777 !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time-list-item--selected {\r\n  background-color: #f0c777 !important;\r\n  color: #242424 !important;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__header--time {\r\n  padding: 8px !important;\r\n}\r\n\r\n.react-datepicker__navigation {\r\n  top: 10px !important;\r\n}\r\n\r\n.react-datepicker__navigation--previous {\r\n  left: 8px !important;\r\n}\r\n\r\n.react-datepicker__navigation--next {\r\n  right: 78px !important;\r\n}\r\n\r\n.react-datepicker__navigation-icon::before {\r\n  border-color: #242424 !important;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 100 !important;\r\n}\r\n\r\n.react-datepicker__triangle {\r\n  display: none !important;\r\n}\r\n\r\n.checkbox-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.checkbox-wrapper input[type=\"checkbox\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  accent-color: #f0c777;\r\n}\r\n\r\n.checkbox-wrapper label {\r\n  font-size: 14px;\r\n  color: #333;\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 420px) {\r\n  /* .wrap {padding-top: 68vh;} */\r\n  .container {\r\n    width: 95%;\r\n  }\r\n\r\n  .wrap {\r\n    padding: 0;\r\n  }\r\n\r\n  .input-wrapper input {\r\n    width: 100%;\r\n  }\r\n\r\n  .solid {\r\n    width: 100%;\r\n  }\r\n\r\n  .ss-area .input-area .input-wrapper span {\r\n    width: 90%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
